import { Component, model, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { sanitizeFields, validateBlank, watchFormRecursively } from '../../../shared/utils/form-utils';

import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormFieldFeedbackPipe } from '../../../pipes/form-field-feedback/form-field-feedback.pipe';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputText } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-login-form',
  imports: [
    ButtonModule,
    InputText,
    InputGroupModule,
    InputGroupAddonModule,
    FormFieldFeedbackPipe,
    ReactiveFormsModule,
    TooltipModule,
    FloatLabelModule,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss'
})
export class LoginFormComponent {
  readonly loginForm = new FormGroup({
    email: new FormControl<string>('', {
      validators: [
        Validators.required,
        Validators.email,
        validateBlank()
      ]
    }),
    password: new FormControl<string>('', [
      Validators.required
    ])
  });

  readonly formWatched = watchFormRecursively(this.loginForm);
  readonly isLoading = model.required<boolean>();
  readonly onSubmit = output<any>();
  readonly id = uuidv4();


  constructor(private readonly messageService: MessageService) { }

  submitForm(): void {
    this.isLoading.set(true);

    if (this.loginForm.invalid) {
      this.isLoading.set(false);
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha todos os campos corretamente!',
        life: 4000
      });
      return;
    }

    sanitizeFields(this.loginForm);
    this.onSubmit.emit(this.loginForm.value);
  }
}
